<script>
import {
  UserIcon,
    UsersIcon,
    ShoppingBagIcon,
    AtSignIcon,
    AwardIcon,
    ArrowUpIcon
} from 'vue-feather-icons';
import {
    Carousel,
    Slide
} from 'vue-carousel';

import Navbar from "@/components/navbar";
import Footer from "@/components/footer";

import config from "@/config.json";
import axios from 'axios';
import {post} from "@/assets/js/utils";
/**
 * Shop-cart component
 */
export default {
    data() {
        const lang = this.getLang();
        return {
          unit: (lang === 'zh')? '￥' : '$',
          lang: lang,
          api_new_trade: `${process.env.VUE_APP_SERVER_HOST}${config.api.newtrade}`,
          access_token: "",
          processing: false,
          isCancelPay: false,
          order_id: "",
          order_total: 1,
          price_total: 0,
          price_discount: 1,
          counter: 0,
          order_error: "",
          auth_owner: false,
          enterprise: {
            enable: false,
            org_id: 0,
            org_name: "一个神奇的组织",
            email_suffix: "@random-mail.com"
          },
          order: {
            order_id: 0,
            uid: 0,
            sku_id: 0,
          },
          coupon: {
            detail: '',
          },
          list: [],
          showGroupUser: false,
          groupUser: [ {follower_email: '', follower_id: 0 }],
          emailAdd: '',
          addTip: '',
          adding: false,
          trade: {a: 100},
          paypal: {
            name: "",
            order_id: "",
            amount: 0,
            notify_url: "",
            cancel_return: "",
            return: ""
          }
        }
    },
    components: {
        Navbar,
        Footer,
        Carousel,
        Slide,
      UserIcon,
      UsersIcon,
      ShoppingBagIcon,
      AtSignIcon,
      AwardIcon,
        ArrowUpIcon
    },
    mounted() {
      console.log(this.$route.query);
      const query = this.$route.query;
      if (query.order_id === undefined) {
        alert(this.$t('cart.param_error'));
        this.$router.push({name: "buy"});
        return;
      }
      this.order_id = query.order_id;
      const accessToken = localStorage.getItem("access_token");
      if (accessToken) {
        this.access_token = accessToken;
      }

      this.getOrderInfo();
    },
  methods: {
    async getOrderInfo() {
      try {
        const {order_id} = this;
        const data = await post(`${config.api.orderinfo}`, {order_id});
        console.log(data);
        if (data.errno === 0) {
          this.order = Object.assign(data.order);
          this.list = [data.order];
          if (this.order.coupon > 0 && data.coupon.value) {
            this.coupon = data.coupon;
            this.price_discount = data.coupon.value;
          } else {
            this.price_discount = 1;
          }
          this.price_total = (this.lang === "zh")? this.order.price * this.price_discount : this.order.price_dollar * this.price_discount;

          // 团购订单，需要单独拉取成员信息
          if (data.is_group_order) {
            this.showGroupUser = true;
            await this.getGroupOrderInfo();
          }
          // 企业订单，需要单独拉取企业信息
          if (data.is_enterprise_order) {
            this.enterprise.enable = true;
            await this.getGroupOrderInfo();
          }
        } else if (data.errno === 12) {
          await this.$router.push('/buy');
        } else {
          this.order_error = this.$t("cart.order.not_exists");
          setTimeout(() => {
              this.$router.push('/buy');
          }, 3000);
        }
      } catch (e) {}
    },
    async getGroupOrderInfo() {
      try {
        const data = await post(`${config.api.grouporderaction}`, {action: "list", order_id: this.order.order_id, email: '', follower_id: 0});
        this.groupUser = data['list'];
        this.order_total = this.groupUser.length;
        if (data.coupon.value) {
          this.coupon = data.coupon;
          this.price_discount = data.coupon.value;
        } else {
          this.price_discount = 1;
        }
        this.price_total = (this.lang === "zh")? this.order.price * this.price_discount : this.order.price_dollar * this.price_discount;
      } catch (e) {}
    },
    async checkOrderStatus() {
      try {
        if (this.isCancelPay) { return; }
        const {order_id} = this;
        const data = await post(`${config.api.orderinfo}`, {order_id});
        if (data.errno === 0) {
          const order = data.order;
          if (order.trade_status === 1) {
            await this.$router.push('/shop-result?order_id='+order_id);
          } else {
            setTimeout(() => this.checkOrderStatus(), 1000);
          }
        }
      } catch (e) {}
    },
    cancelPay() {
      this.isCancelPay = true;
    },
    newTradePaypal() {
      this.$bvModal.show("buy-status");
    },
    async newTrade() {
      this.isCancelPay = false;
      this.$bvModal.show("pay-modal");
      setTimeout(() => this.checkOrderStatus(), 2000);
    },
    async addUser() {
      try {
        if (this.emailAdd.trim() === "") { return; }
        this.adding = true;
        if (this.enterprise.enable) {
          const data1 = await post(`${config.api.orgorderaction}`, {action: "add", order_id: this.order.order_id, email: this.emailAdd, follower_id: 0});
          if (data1.errno !== 0) {
            this.addTip = data1.info;
            this.adding = false;
            return;
          }
        }
        const data = await post(`${config.api.grouporderaction}`, {action: "add", order_id: this.order.order_id, email: this.emailAdd, follower_id: 0});
        if (data.errno === 0) {
          this.emailAdd = "";
          await this.getOrderInfo();
        } else {
          this.addTip = data.info;
        }
        this.adding = false;
      } catch (e) {
        this.adding = false;
      }
    },
    async removeUser(uid, email) {
      try {
        const data = await post(`${config.api.grouporderaction}`, {action: "remove", order_id: this.order.order_id, email, follower_id: uid});
        if (data.errno === 0) {
          await this.getOrderInfo();
        }
      } catch (e) { }
    },

  }

}
</script>

<template>
<div>
    <Navbar :nav-light="true" />

    <!-- Hero Start -->
    <section class="bg-half bg-danger d-table w-100" style="background: url('/images/account/bg.png') center center;">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-lg-12 text-center">
                    <div class="page-next-level">
                        <h3 class="title text-white"> {{$t('cart.title')}} </h3>
                    </div>
                </div>
                <!--end col-->
            </div>
            <!--end row-->
        </div>
        <!--end container-->
    </section>
    <!--end section-->
    <div class="position-relative">
        <div class="shape overflow-hidden text-white">
            <svg viewBox="0 0 2880 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z" fill="currentColor"></path>
            </svg>
        </div>
    </div>
    <!-- Hero End -->

    <!-- Start -->
    <section class="section">
        <div class="container">
            <div class="row" v-if="list.length > 0">
                <div class="col-12">
                    <div class="table-responsive bg-white shadow">
                        <table class="table table-center table-padding mb-0">
                            <thead>
                                <tr>
                                    <th class="py-3" style="min-width: 300px;">{{$t('cart.order.name')}}</th>
                                    <th class="text-center py-3" style="min-width: 160px;">{{$t('cart.order.description')}}</th>
                                    <th class="text-center py-3" style="min-width: 160px;">{{$t('cart.order.price')}}</th>
                                  <th class="text-center py-3" style="min-width: 160px;">{{$t('cart.order.number')}}</th>
                                  <th class="text-center py-3" style="min-width: 160px;">{{$t('cart.order.created_at')}}</th>
                                </tr>
                            </thead>

                            <tbody>
                                <tr v-for="(item, index) of list" :key="index">
                                    <td>
                                        <div class="d-flex align-items-center">
                                            <h6 class="mb-0">{{lang === "zh"? item.name : item.name_en}}</h6>
                                        </div>
                                    </td>
                                  <td class="text-center">{{lang === "zh"? item.description : item.description_en}}</td>
                                  <td class="text-center">
                                    <span v-if="price_discount !== 1" style="text-decoration: line-through" class="text-sm-left">{{lang === "zh"? item.price : item.price_dollar}}</span>
                                    {{lang === "zh"? item.price * price_discount : item.price_dollar * price_discount}}{{unit}}
                                  </td>
                                  <td class="text-center"> {{order_total}} </td>
                                  <td class="text-center">{{item.created_at | formatDate}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <!--end col-->
            </div>
            <!--end row-->

          <div class="group-order mt-5" v-if="showGroupUser || enterprise.enable">
            <h5 v-if="!enterprise.enable">{{$t('cart.group_order.title')}}</h5>
            <h5 v-if="enterprise.enable">{{$t('cart.org.title')}}</h5>
            <div class="row">
              <div class="col-8">
                <div class="table-responsive bg-white shadow">
                  <table class="table table-center table-padding mb-0">
                    <thead>
                    <tr>
                      <th>#</th>
                      <th class="py-3" style="min-width: 100px;">{{$t('cart.order.name')}}</th>
                      <th class="py-3" style="min-width: 160px;">{{$t('cart.group_order.email')}}</th>
                      <th class="py-3 text-center">{{$t('cart.group_order.remove')}}</th>
                    </tr>
                    </thead>

                    <tbody>
                    <tr v-for="(item, index) of groupUser" :key="index">
                      <td>{{index+1}}</td>
                      <td>
                        <div class="d-flex align-items-center">
                          <h6 class="mb-0">{{$t('cart.group_order.name')}}</h6>
                        </div>
                      </td>
                      <td class="text-left">{{item.follower_email}}</td>
                      <td class="text-center">
                        <a v-if="item.follower_id !== order.uid" href="#" @click.prevent="removeUser(item.follower_id, item.follower_email)" class="text-dark"><i class="mdi mdi-delete"></i></a>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <!--end col-->
              <div class="col-4"> </div>

            </div>
            <!--end row-->
            <form class="login-form mt-3" @submit.prevent="addUser">
              <label v-if="!enterprise.enable">{{$t('cart.group_order.add')}}</label >
              <label v-if="enterprise.enable">{{$t('cart.org.add')}}</label >
              <p v-if="enterprise.enable" style="font-size: 12px; color: #666" v-html="$t('cart.org.add_info')"></p>
              <div class="row" v-if="addTip !== ''">
                <div class="col-lg-4">
                  <div class="alert alert-danger">{{addTip}}</div>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-4">
                  <div class="form-group">
                    <div class="position-relative">
                      <user-icon class="fea icon-sm icons"></user-icon>
                      <input type="email" @focus="addTip = ''" v-model="emailAdd" class="form-control pl-5" :placeholder="$t('login.emailTip')" name="email" required="" />
                    </div>
                  </div>
                </div>
                <div class="col-lg-4">
                  <button :disabled="adding" class="btn btn-info">{{$t('cart.group_order.add_button')}}</button>
                </div>
                <!--end col-->
              </div>

            </form>
          </div>
          <!--end row-->

          <div class="row" v-if="list.length > 0">
                <div class="col-lg-6 col-md-6 ml-auto mt-4 pt-2">
                    <div class="table-responsive bg-white rounded shadow">
                        <table class="table table-center table-padding mb-0">
                            <tbody>
                              <tr v-if="price_discount !== 1">
                                <td class="h6">已使用优惠</td>
                                <td class="text-center"><award-icon class="fea icon-sm"></award-icon>{{coupon.detail}}</td>
                              </tr>
                                <tr class="bg-light">
                                    <td class="h6">{{$t('cart.order.total')}}</td>
                                    <td class="text-center font-weight-bold">
                                      <span v-if="price_discount !== 1"><span style="color: gray;text-decoration:line-through">{{order.price}}</span> {{price_total}} {{unit}}</span>
                                      <span v-else>{{price_total}} {{unit}}</span>
                                    </td>
                                </tr>

                            </tbody>
                        </table>
                    </div>
                    <div class="mt-4 pt-2 text-right">

                      <form target="pay-frame" id="alipay-submit" name="alipay-submit" :action="api_new_trade" method="post" v-if="lang === 'zh'">
                        <!--<input type="hidden" v-for="(val, key) in trade" :name="key" :value="val" /> -->
                        <input type="hidden" name="locale" :value="lang"/>
                        <input type="hidden" name="order_id" :value="order_id"/>
                        <input type="hidden" name="access_token" :value="access_token"/>
                        <input type="hidden" name="order_total" :value="order_total"/>
                        <input type="hidden" name="org_id" :value="enterprise.org_id"/>
                        <input type="hidden" name="org_name" :value="enterprise.org_name"/>
                        <input type="hidden" name="email_suffix" :value="enterprise.email_suffix"/>

                        <button :disabled="price_total === 0" @click="newTrade" type="submit" class="btn btn-primary">
                          <font-awesome-icon :icon="['fab', 'alipay']"></font-awesome-icon>
                          <span class="ml-2">{{$t('cart.order.checkout')}}</span>
                        </button>
                      </form>

                      <form :action="api_new_trade" method="post" target="_blank" id="paypal-submit" name="paypal-submit" v-if="lang === 'en'">
                        <input type="hidden" name="access_token" :value="access_token"/>
                        <input type="hidden" name="order_id" :value="order_id"/>
                        <input type="hidden" name="locale" :value="lang"/>
                        <input type="hidden" name="order_total" :value="order_total"/>
                        <input type="hidden" name="org_id" :value="enterprise.org_id"/>
                        <input type="hidden" name="org_name" :value="enterprise.org_name"/>
                        <input type="hidden" name="email_suffix" :value="enterprise.email_suffix"/>

                        <button @click="newTradePaypal" type="submit" class="btn btn-primary">
                          <font-awesome-icon :icon="['fab', 'paypal']"></font-awesome-icon>
                          <span class="ml-2">{{$t('cart.order.checkout')}}</span>
                        </button>
                      </form>

                    </div>
                </div>
                <!--end col-->
            </div>
            <!--end row-->

          <div class="row" v-if="order_error !== ''">
            <div class="col-12 text-center">
              <h4>{{order_error}}</h4>
            </div>
          </div>

        </div>
      <!--end container-->


      <b-modal id="pay-modal" size="lg" ref="pay-modal"
               hide-footer
               :title="$t('cart.pay_modal_title')"
               @close="cancelPay"
               no-close-on-backdrop
               centered>

        <iframe scrolling="none" style="border: none" width="600" height="300" id="pay-frame" name="pay-frame"/>

      </b-modal>



      <b-modal id="buy-status" size="sm" ref="buy-status" hide-footer
               hide-header-close
               :title="$t('cart.status_title')"
               header-close-variant="white"
               no-close-on-backdrop
               header-class="border-0"
               content-class="border-0" centered >
        <!--
          必须用 router-link。这里原本是普通的 a 标签绑 href，属于整页跳转，
          拿不到 /en 前缀，英文用户付完款点这两个按钮会落到中文的支付结果页。
        -->
        <p class="text-center"><router-link :to="'/shop-result?order_id=' + order.order_id" class="btn btn-primary">{{$t('cart.status_success')}}</router-link></p>
        <p class="text-center"><router-link :to="'/shop-result?order_id=' + order.order_id" class="btn btn-warning">{{$t('cart.status_fail')}}</router-link></p>
      </b-modal>

    </section>
    <!--end section-->
    <!-- End -->
    <!--end section-->
    <Footer />
    <!-- Footer End -->
    <!-- Back to top -->
    <a href="javascript: void(0);" class="btn btn-icon btn-primary back-to-top" id="back-to-top" v-scroll-to="'#topnav'">
        <arrow-up-icon class="icons"></arrow-up-icon>
    </a>
    <!-- Back to top -->
</div>
</template>
